<app-header-component></app-header-component>
<app-big-picture-advertisement></app-big-picture-advertisement>
<app-blocks-detail></app-blocks-detail>
<app-big-block-details></app-big-block-details>
<app-campus></app-campus>
<app-story-of-success></app-story-of-success>
<app-wearesocial></app-wearesocial>
<app-footer></app-footer>